import { FormattedMessage, type MessageDescriptor } from 'react-intl';

import Heading from '@atlaskit/heading';
import { Box, Flex, xcss } from '@atlaskit/primitives-next';

const containerStyles = xcss({
	borderRadius: '6px',
	borderColor: 'color.border',
	borderWidth: 'border.width',
	borderStyle: 'solid',
	width: '100%',
	boxSizing: 'border-box',
	height: '200px',
});

const outerContentStyles = xcss({
	height: '100%',
});

const contentStyles = xcss({
	flexGrow: 1,
});

export const BaseCard = ({
	children,
	message,
}: {
	children: React.ReactNode;
	message: MessageDescriptor;
}) => {
	return (
		<Box padding="space.150" xcss={containerStyles} as="article">
			<Flex xcss={outerContentStyles} direction="column" gap="space.100">
				<Heading size="xsmall" as="h3">
					<FormattedMessage {...message} />
				</Heading>
				<Box xcss={contentStyles}>{children}</Box>
			</Flex>
		</Box>
	);
};
